function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import window from '../sdk/windowWrapper';

var TranslationUtil = /*#__PURE__*/function () {
  function TranslationUtil() {
    this._translations = Object.assign({}, _objectSpread({}, window.translations));
  }

  var _proto = TranslationUtil.prototype;

  _proto.setTranslations = function setTranslations(translations) {
    Object.assign(this._translations, _objectSpread({}, translations));
  };

  _proto.getByKey = function getByKey(strKey) {
    try {
      var strValue = null;

      if (this.translations) {
        strValue = this.translations[strKey] || window.translations[strKey];
      }

      if (!strValue) {
        strValue = strKey;
      }

      if (window) {
        if (window.isClientDev) {
          strValue = strKey;
        }

        if (window.unescape) {
          strValue = window.unescape(strValue); // for chars that come from babel like &#39;
        }
      }

      return strValue;
    } catch (e) {
      return strKey;
    }
  };

  _createClass(TranslationUtil, [{
    key: "translations",
    get: function get() {
      return this._translations;
    }
  }]);

  return TranslationUtil;
}();

export default new TranslationUtil();